import { Component, OnInit, ViewChild, ViewContainerRef, ViewChildren, QueryList, OnDestroy, ElementRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GridsterConfig } from "angular-gridster2";
import { DialogService } from "src/modules/base/components/dialog/dialog.service"
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { LoaderService } from '../../services/loader.service';
import { DashboardService } from "../dash-board/services/dashboard.service";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { StorageService } from "../../shared/services/storage.service";
import { UtilService } from "../../services/util.service";
import { AppSidebarService } from "../../layout/coreui/sidebar/app-sidebar.service";
import { TemplateInterceptorComponent } from 'src/modules/base/components/template-interceptor/template-interceptor.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { AppService } from 'src/modules/base/shared/services/app.service';

@Component({
    selector: 'app-dynamic-dashboard',
    templateUrl: './dynamic-dashboard.component.html',
    styleUrls: ['./dynamic-dashboard.component.scss'],
    standalone: false
})
export class DynamicDashboardComponent implements OnInit, OnDestroy {
  widgetCollection: any = [];
  config: any = {};
  loggedUser:any
  constructor(private _route: ActivatedRoute,
    private dialogService: DialogService,
    private baseService: BaseService,
    private appService: AppService,
    private communicationService: CommunicationService,
    public dashBoardService:DashboardService,
    private auth: AuthenticationService,
    private loader: LoaderService,
    private storage: StorageService,
    private utilService: UtilService,
    public sideBar:AppSidebarService,
    private elementRef?: ElementRef) {
      this.config.dashboardLoaded = false;
      this.config.isOnlyMobile = utilService.isOnlyMobile();
      this.config.allowedFullScreen = ['app-chart-doughnut','app-chart','data-grid-widget','app-composite-chart'];
     }
  public options: GridsterConfig;
  public dashboardId: number;
  public dashboardCollection: any;
  public dashboardArray: any[];
  @ViewChildren('customComponent', { read: ViewContainerRef }) customComponent: QueryList<ViewContainerRef>;

  ngOnInit() {
    this.baseService.setTitle("Dashboard");
    if(this.auth.getUserType() == "patient"){
      this.storage.setCurrentResource("patient_dynamic_dashboard")
    }
    this.options = this.dashBoardService.getGridsterOption();
    this.options.emptyCellDropCallback = ()=>{};
    this.options.draggable.enabled = false;
    this.options.resizable.enabled = false;
    this.getData();
    this.loggedUser = JSON.parse(localStorage.getItem("LoggedInUser"));
    if(this.loggedUser?.user_id){ // first time login take consent
       this.FirstTimeTakeConsent()
    }
    
  }

  ngAfterViewInit() {


  }
  setComponet() {
    setTimeout(() => {
      this.dashboardArray.forEach((item: any, index) => {
        this.setSingleComponet(item,index);
      })
    })
  }
  
  setSingleComponet(item,index) {		
		var selector = item['widg_selector'] || item['selector'];
		if(selector){
			this.createComponent(item,selector,index);
		}
	}

	createComponent(item,selector,index){
    this.baseService.createComponent(selector, this.customComponent.toArray()[index], (response) => {
      response.instance.data = item;
      this.dashboardArray[index]["response"] = response;
      response.instance.resource = item.resource;
      if (response.instance.configChanged) {
        response.instance.configChanged.subscribe(elem => {
          item.config = { ...item.config, ...elem.config }
        })
      }
      response.changeDetectorRef.detectChanges();
    });
	}

  makeFullScreen(index,fullScreen){
    try{
     if( this.dashboardArray[index]["response"]["instance"]["makeFullScreen"] != undefined){
      this.dashboardArray[index]["response"]["instance"]["makeFullScreen"](fullScreen);
     }
    }catch(e){
      console.warn(e)
    }
   
  }


  getDashboardData(dashboard){
    if (dashboard != undefined && dashboard.resource != undefined && dashboard.resource.length>0) {
      if(dashboard.resource[0].name != undefined){
        this.baseService.setTitle(dashboard.resource[0].name);
        this.config.name = dashboard.resource[0].name;
      }
      if (dashboard.resource[0].dashboard == ''){
        dashboard.resource[0].dashboard = [];
      }
      else{
        dashboard.resource[0].dashboard = JSON.parse(dashboard.resource[0].dashboard)

        if(this.utilService.isMobile()){
          dashboard.resource[0].dashboard = this.assignSerialNumbers(dashboard.resource[0].dashboard);
        }
      }
        
      this.dashboardCollection = dashboard.resource[0];
      return this.dashboardCollection.dashboard.slice();
  }
  }

  assignSerialNumbers(arr) {
    // Split the array into two parts: with both x and y defined, and without
    const withXYDefined = arr.filter(item => item.x !== undefined && item.y !== undefined);
    const withoutXYDefined = arr.filter(item => item.x === undefined || item.y === undefined);
  
    // Sort the part with both x and y defined by y, then by x
    withXYDefined.sort((a, b) => (a.y === b.y ? a.x! - b.x! : a.y! - b.y!));
  
    // Assign serial numbers to the part with both x and y defined
    const arrayWithSerialNumbers = withXYDefined.map((item, index) => {
      return { ...item, serialNumber: index + 1 };
    });
  
    // Concatenate the part without both x and y defined to the end
    return arrayWithSerialNumbers.concat(withoutXYDefined);
  }
  
  getData() {
    this._route.params.subscribe(params => {
        this.loader.showSpinner();
          let obj = { 
            "projectionKeys": "id,g_status,g_creation_time,g_modify_time,name,identifier,url,role,dashboard,account_id,tag_data",
            args: 'identifier:' + params.identifier 
          }
          this.baseService.getData(obj, '', 'dashboard_master_list', 'account-management', 'GET_DATA_PER_ROLE').subscribe(dashboard => {
            
            var dashboardArray = this.getDashboardData(dashboard);
            if(dashboardArray && dashboardArray.length>0){
                this.dashboardArray = dashboardArray;
                this.config.dashboardLoaded = true;
                this.defaultHideSidebar() // only for kisok user admin --author : abhimanyu
                this.loader.hideSpinner();
                setTimeout(() => { this.setComponet(); })
            }else{
              this.loader.hideSpinner();
              this.config.dashboardLoaded = true;
            }
          },
          err=>{
            this.loader.hideSpinner();
            this.config.dashboardLoaded = true;
          });
    });
  }

  defaultHideSidebar() {  // Only for kiosk/admin author -- abhimanyu
    if (this.loggedUser && this.loggedUser.is_kiosk === true) {
      // Minimize the sidebar if the user is a kiosk user
      this.sideBar.toggle({ minimize: true });
    } else {
      console.log("The User is not a kiosk.");
    }
  }

  ngOnDestroy() {
   
  }


  FirstTimeTakeConsent() { // first time login take consent
    this.baseService.get('GET_BY_ID', 'id:' + this.loggedUser.user_id, 'account_user', 'account-management').subscribe( (userData) => {
        const user = userData?.resource?.[0];
        if (userData?.errCode === 0 && user && user.user_type === "patient" && user.is_consent_pending) {
          this.baseService.getPatientUHID().subscribe((res) => {
              const uhid = res?.resource?.[0];
              if (uhid) {
                const _khaliObj = { ...uhid, ...user,...this.loggedUser, patient_id: uhid.id };
                _khaliObj['facility_id'] = _khaliObj['facility_id'] ?? this.loggedUser?.facilities?.[0]?.org_id ?? '';
                this.checkTemplates(_khaliObj)
              }
            }
          );
        }
      })
  }

  getTemplateConfig(type?) {
    const isSelfRegistration = type?.screen_name === "self_registration";
    return {
      next_stage: "Booked",
      emitOnSubmit: true,
      result_key: "services",
      hideToaster: true,
      checkPre: true,
      setPrint: true,
      addExtrakey: true,
      accepted: true,
      datasource: {
        query_id: "get_template_from_master",
        application: "form-template-engine",
        resource: "templateTransaction",
        filter: "",
        args: `action_code:${isSelfRegistration ? "self_registration" : "first_login"},module_id:${isSelfRegistration ? "patient-registration" : "login"},template_type:consent_form,consent_type_id:data_privacy_consent`
      }
    };
  }

  checkTemplates(data, menuParser?) {
    try {
      this.loader.showSpinner();
      let datasource = this.getTemplateConfig(data).datasource;
      datasource.args += ',facility_id:' + data.facility_id
      let result = data != undefined ? data : undefined;
      if (result != undefined && !result.care_type) {
        try {
          result['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType");
        } catch (error) { }
      }
      result['facility_id'] = data.facility_id
      result['currentAction'] = data?.screen_name === "self_registration" ? "Self Registration" : "first time login"
      let args = this.baseService.buildDyanamicStr(datasource.args, { data: result });
      this.baseService.get(datasource.query_id, args, datasource.resource, datasource.application, datasource.filter).subscribe(res => {
        if (res.errCode != -1 && res && res.resource != undefined && res.resource.length != undefined && res.resource.length > 0) {
          let obj = this.getTemplateConfig();
          obj['TemplateData'] = res.resource;
          this.loader.hideSpinner();
          this.openTemplIntersep(result, { templateInterceptor: obj }, false, (templateRes) => {
            if (templateRes) {
              result[this.getTemplateConfig().result_key] = templateRes;
            }
          });
        }
        else {
          this.loader.hideSpinner();
        }
      })

    } catch (error) {
    }
  }

  openTemplIntersep(data: any, actionType, config?, callback?) {
    data['facility_id'] = data.facility_id ?? ""
    let popobj = { data: { action: actionType, data: data }, title: 'Template', size: DialogModalSize.Lg, closehide: "hide" };
    if (config)
      popobj.data['config'] = config
    this.dialogService.open(TemplateInterceptorComponent, popobj).afterClosed.subscribe(
      res => {
        if (res) {
          callback(res);
        } else {
          callback(false);
        }
      });
  }
}


